import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { GET_CABRIDE_FAILED, GET_CABRIDE_REQUESTED, GET_CABRIDE_SUCCESS, GET_DASHBOARDFEEDBACK_FAILED, GET_DASHBOARDFEEDBACK_REQUESTED, GET_DASHBOARDFEEDBACK_SUCCESS, GET_OURCAR_FAILED, GET_OURCAR_REQUESTED, GET_OURCAR_SUCCESS, GET_RIDEACCEPT_FAILED, GET_RIDEACCEPT_REQUESTED, GET_RIDEACCEPT_SUCCESS, GET_TOPDRIVER_FAILED, GET_TOPDRIVER_REQUESTED, GET_TOPDRIVER_SUCCESS, GET_TOPSUBVENDOR_FAILED, GET_TOPSUBVENDOR_REQUESTED, GET_TOPSUBVENDOR_SUCCESS, GET_TOPVENDOR_FAILED, GET_TOPVENDOR_REQUESTED, GET_TOPVENDOR_SUCCESS } from "resources/actionTypes";
import { cabRideApi, dashboardFeedbackApi, ourCarApi, rideAcceptApi, topDriverApi, topSubVendorApi, topVendorApi } from "services/TopSectionService";

function* fetchOurCar(action) {
  try {
    const payload = action.payload || {}
    const userOurCar = yield call(ourCarApi, payload);
    yield put({ type: GET_OURCAR_SUCCESS, userOurCar: userOurCar });
  } catch (e) {
    yield put({ type: GET_OURCAR_FAILED, message: e.message });
    toast.error(e.message || 'Get Our Car Failed')
  }
}

export function* userOurCarSaga() {
  yield takeEvery(GET_OURCAR_REQUESTED, fetchOurCar);
}

function* fetchCabRide(action) {
  try {
    const payload = action.payload || {}
    const userCabRide = yield call(cabRideApi, payload);
    yield put({ type: GET_CABRIDE_SUCCESS, userCabRide: userCabRide });
  } catch (e) {
    yield put({ type: GET_CABRIDE_FAILED, message: e.message });
    toast.error(e.message || 'Get Cab Ride Failed')
  }
}

export function* userCabRideSaga() {
  yield takeEvery(GET_CABRIDE_REQUESTED, fetchCabRide);
}

function* fetchTopVendor(action) {
  try {
    const payload = action.payload || {}
    const userTopVendor = yield call(topVendorApi, payload);
    yield put({ type: GET_TOPVENDOR_SUCCESS, userTopVendor: userTopVendor });
  } catch (e) {
    yield put({ type: GET_TOPVENDOR_FAILED, message: e.message });
    toast.error(e.message || 'Get Top Vendor Failed')
  }
}

export function* userTopVendorSaga() {
  yield takeEvery(GET_TOPVENDOR_REQUESTED, fetchTopVendor);
}

function* fetchTopSubVendor(action) {
  try {
    const payload = action.payload || {}
    const userTopSubVendor = yield call(topSubVendorApi, payload);
    yield put({ type: GET_TOPSUBVENDOR_SUCCESS, userTopSubVendor: userTopSubVendor });
  } catch (e) {
    yield put({ type: GET_TOPSUBVENDOR_FAILED, message: e.message });
    toast.error(e.message || 'Get Top SubVendor Failed')
  }
}

export function* userTopSubVendorSaga() {
  yield takeEvery(GET_TOPSUBVENDOR_REQUESTED, fetchTopSubVendor);
}

function* fetchTopDriver(action) {
  try {
    const payload = action.payload || {}
    const userTopDriver = yield call(topDriverApi, payload);
    yield put({ type: GET_TOPDRIVER_SUCCESS, userTopDriver: userTopDriver });
  } catch (e) {
    yield put({ type: GET_TOPDRIVER_FAILED, message: e.message });
    toast.error(e.message || 'Get Top Driver Failed')
  }
}

export function* userTopDriverSaga() {
  yield takeEvery(GET_TOPDRIVER_REQUESTED, fetchTopDriver);
}

function* fetchRideAccept(action) {
  try {
    const payload = action.payload || {}
    const userRideAccept = yield call(rideAcceptApi, payload);
    yield put({ type: GET_RIDEACCEPT_SUCCESS, userRideAccept: userRideAccept });
  } catch (e) {
    yield put({ type: GET_RIDEACCEPT_FAILED, message: e.message });
    toast.error(e.message || 'Get Top Driver Failed')
  }
}

export function* userRideAcceptSaga() {
  yield takeEvery(GET_RIDEACCEPT_REQUESTED, fetchRideAccept);
}

function* fetchDashboardFeedback(action) {
  try {
    const payload = action.payload || {}
    const userDashboardFeedback = yield call(dashboardFeedbackApi, payload);
    yield put({ type: GET_DASHBOARDFEEDBACK_SUCCESS, userDashboardFeedback: userDashboardFeedback });
  } catch (e) {
    yield put({ type: GET_DASHBOARDFEEDBACK_FAILED, message: e.message });
    toast.error(e.message || 'Get Dashboard Feedback Failed')
  }
}

export function* userDashboardFeedbackSaga() {
  yield takeEvery(GET_DASHBOARDFEEDBACK_REQUESTED, fetchDashboardFeedback);
}